module.exports = __webpack_public_path__ + "static/img/4EBCEE56-11B7-40b1-9F24-0BCCD0D0E1A9.2496e229.png";